var React = require('react');

function Twitter (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M28 2.93a11.345 11.345 0 0 1-3.299.914A5.807 5.807 0 0 0 27.229.632a11.412 11.412 0 0 1-3.65 1.407A5.702 5.702 0 0 0 19.384.207c-3.17 0-5.743 2.6-5.743 5.806 0 .455.05.897.149 1.322-4.775-.242-9.007-2.551-11.842-6.068a5.846 5.846 0 0 0-.777 2.922 5.821 5.821 0 0 0 2.555 4.833 5.702 5.702 0 0 1-2.603-.725v.072c0 2.814 1.98 5.161 4.61 5.693-.481.136-.99.204-1.514.204a5.66 5.66 0 0 1-1.08-.103c.73 2.306 2.85 3.985 5.365 4.03a11.445 11.445 0 0 1-7.134 2.487c-.464 0-.922-.026-1.371-.08a16.16 16.16 0 0 0 8.806 2.607c10.567 0 16.344-8.846 16.344-16.52 0-.252-.005-.504-.015-.752A11.692 11.692 0 0 0 28 2.93z","fill":"currentColor"}));
}

Twitter.defaultProps = {"viewBox":"0 0 28 24","fill":"none"};

module.exports = Twitter;

Twitter.default = Twitter;
